// ink-component
import React, { ReactNode, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

import DropdownAura from '../DropdownAura/DropdownAura';
import { dropdownTokens } from '../../../../tokens/components/Dropdown/tokens';
import { fontTokens } from '../../../../tokens/globals/tokens';
import { StyledAnchor } from '../../../Anchor/Anchor';

export interface DropdownHeaderProps {
  /** Header's text */
  children?: ReactNode;
  /** Should stick the Header on top or not */
  sticky?: boolean;
}

/* @internal */
export const DropdownHeaderWrapper = styled.p`
  align-items: baseline;
  color: ${dropdownTokens.HeaderFontColorBaseDefault};
  display: flex;
  font-size: ${dropdownTokens.HeaderFontSizeBaseDefault};
  font-weight: ${dropdownTokens.HeaderFontWeightBaseDefault};
  line-height: ${dropdownTokens.HeaderFontLeadingBaseDefault};
  justify-content: space-between;
  margin: ${dropdownTokens.HeaderSpacingVerticalTopBaseDefault} ${dropdownTokens.HeaderSpacingHorizontalBaseDefault}
    ${dropdownTokens.HeaderSpacingVerticalBottomBaseDefault};
  user-select: none;
  white-space: normal;

  ${StyledAnchor} {
    font-size: ${fontTokens.GlobalSizeSmall2};
  }
`;

/**
 * @purpose A header separator for Dropdown.Item(s)
 * @categories navigation
 * @group Dropdown
 */
const DropdownHeader = (props: DropdownHeaderProps) => {
  const { sticky, children } = props;
  const themeContext = useContext(ThemeContext);

  return (
    <DropdownAura theme={{ ...themeContext, sticky }}>
      <DropdownHeaderWrapper>{children}</DropdownHeaderWrapper>
    </DropdownAura>
  );
};

DropdownHeader.defaultProps = {
  children: undefined,
  sticky: false,
};

DropdownHeader.displayName = 'Dropdown.Header';

export default DropdownHeader;
